import React from 'react';
import { Modal, Button } from 'antd';
import PropTypes from 'prop-types';
import eliminarRegistro from 'assets/images/eliminar_monitoreo.jpg';
import './ModalEliminarRegistro.scss';

const ModalEliminarRegistro = ({ open, openSuccess, confirmDelete, handleCerrar }) => {
  const onOk = () => {
    console.log('Confirmar eliminado');
    confirmDelete?.();
  };
  return (
    <div>
      <Modal width="30%" footer={null} open={open} onCancel={handleCerrar} centered>
        <div className="msj-confirmación-eliminar">¿Deseas eliminar el registro?</div>
        <div className="contenedor-botones-eliminar-registro">
          <Button className="buttons-cancelar-elimiar-registro" onClick={handleCerrar}>
            Cancelar
          </Button>
          <Button type="primary" className="buttons-aceptar-elimiar-registro" onClick={onOk}>
            Aceptar
          </Button>
        </div>
      </Modal>
      <Modal open={openSuccess} title="" footer={null} width="33%" onCancel={handleCerrar} centered>
        <div>
          <div className="contenedor-msj-eliminar-registro-exitoso">
            <img alt="example" style={{ width: '33%', marginTop: '3em' }} src={eliminarRegistro} />
            <span className="msj-eliminar-registro-exitoso">Registro eliminado exitosamente.</span>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ModalEliminarRegistro;

ModalEliminarRegistro.propTypes = {
  open: PropTypes.bool,
  openSuccess: PropTypes.bool.isRequired,
  handleCerrar: PropTypes.func.isRequired,
  confirmDelete: PropTypes.func.isRequired
};

ModalEliminarRegistro.defaultProps = {
  open: false
};
